// Money / date formatting shared by the Revenue tracker and Overdue
// views, so the same amount never renders two different ways depending
// on which tab you are on.

export const CURRENCY_SYMBOL = { INR: "₹", USD: "$" };

// Headline / summary figure: whole units, native currency styling.
export function fmt(amount, currency) {
  const num = Number(amount) || 0;
  const code = String(currency || "INR").toUpperCase();
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: code,
      maximumFractionDigits: 0,
    }).format(num);
  } catch {
    return `${code} ${num.toLocaleString("en-IN")}`;
  }
}

// Per-bill amount: 2dp with the plain currency symbol (₹ / $).
export function fmtBillAmount(amount, currency) {
  const num = Number(amount) || 0;
  const code = String(currency || "INR").toUpperCase();
  const sym = CURRENCY_SYMBOL[code] || `${code} `;
  return `${sym}${num.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

// Short date for a bill row.
export function fmtBillDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}
